import { render, staticRenderFns } from "./IconKeywords.vue?vue&type=template&id=392499f0&"
import script from "./IconKeywords.vue?vue&type=script&lang=js&"
export * from "./IconKeywords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('392499f0')) {
      api.createRecord('392499f0', component.options)
    } else {
      api.reload('392499f0', component.options)
    }
    module.hot.accept("./IconKeywords.vue?vue&type=template&id=392499f0&", function () {
      api.rerender('392499f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconKeywords.vue"
export default component.exports